export enum SideType {
  anticlockwise,
  clockwise,
  northBound,
  northEastBound,
  eastBound,
  southEastBound,
  southBound,
  southWestBound,
  westBound,
  northWestBound
}



// WEBPACK FOOTER //
// ./src/app/models/enums/sidetype.ts